// Shared active-highlight for header/navbar chrome buttons (Messenger,
// NotificationBell, AppAssistantToggle, …). The house active/selected
// surface — the `selected` wash token + title text (DESIGN_LANGUAGE.md
// §4.3) — matching the AppNavbar active route, the org switcher, and the
// settings rail. (The old near-opaque `overlayStrong` block is retired
// from state duty: it inverted the active state on light shells.)
//
// Spread onto a button AND pair with `class: { isActive: <factory that
// reads the open signal directly> }`. The class factory MUST read the
// reactive source itself (e.g. `s.root._chatDrawerOpen`) — NOT the
// resolved `el.active` prop: a sibling factory reading `el.active`
// doesn't subscribe to the underlying signal, so it freezes at mount
// (verified live 2026-06-14 — that's why honoring `active:` on the brand
// IconButton couldn't work, and the visual lives on each component
// instead, where it owns its own signal and renders wherever it mounts).
export const activeHighlight = {
  '.isActive': { background: 'selected', color: 'title' }
}
